import { render, staticRenderFns } from "./PTasting.vue?vue&type=template&id=bc49b968&scoped=true&"
import script from "./PTasting.vue?vue&type=script&lang=js&"
export * from "./PTasting.vue?vue&type=script&lang=js&"
import style0 from "./PTasting.vue?vue&type=style&index=0&id=bc49b968&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc49b968",
  null
  
)

export default component.exports